import ValidationService from './ValidationService';

export default ValidationService;
